import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../config";
import moment from "moment";
import Pagination from "../../Pagination/Pagination";
import Loader from "../Loader/Loader";
import { useAppContext } from "../../Lib/ContextLib";

export default function RefferalList({ id }) {
  const { accessObject } = useAppContext();
  const [referralData, setReferralData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [recordLength, setRecordLength] = useState(5);
  const [totalLength, setTotalLength] = useState(0);
  const [showPrePage, setShowPrePage] = useState(5);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start, end });
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  useEffect(() => {
    if (id) {
      fetchReferralData();
    } else {
      setLoading(false);
    }
  }, [id, pageNumber, recordLength]);

  const fetchReferralData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}/api/admin/player/get-referral-details`,
        {
          params: {
            page: pageNumber,
            limit: recordLength,
            search: id,
          },
        }
      );

      if (response.data.status) {
        setReferralData(response.data.data.data);
        setTotalLength(response.data.data.totalLength);
      }
    } catch (error) {
      console.error("Error fetching referral data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="card-body" style={{ overflow: "scroll" }}>
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>SrNo</th>
              <th style={{ textAlign: "center" }}>Referral ID</th>
              <th style={{ textAlign: "center" }}>Username</th>
              <th style={{ textAlign: "center" }}>Name</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  <Loader />
                </td>
              </tr>
            ) : referralData.length > 0 ? (
              referralData.map((referral, index) => (
                <tr key={referral._id} style={{ textAlign: "center" }}>
                  <td>{(pageNumber - 1) * recordLength + index + 1}</td>
                  <td>{referral._id}</td>
                  <td>{referral.userName || "-"}</td>
                  <td>{referral.name || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="text-center py-5">
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="mb-3 rounded-circle d-flex align-items-center justify-content-center" style={{ width: "80px", height: "80px", backgroundColor: "#f8fafc" }}>
                      <i className="fas fa-users-slash text-muted" style={{ fontSize: "32px" }}></i>
                    </div>
                    <h5 className="text-muted font-weight-bold mb-1">No Referrals</h5>
                    <p className="text-muted small mb-0">This player has not referred any users yet.</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {referralData.length > 0 && (
          <Pagination
            updateShowPerpagevalue={updateShowPerpagevalue}
            showPrePage={showPrePage}
            onPaginationChange={onPaginationChange}
            total={referralData.length}
            paginationTypeApi={true}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            recordLength={recordLength}
            setRecordLength={setRecordLength}
            totalLength={totalLength}
          />
        )}
      </div>
    </div>
  );
}
